import * as React from "react";
import { useState, useMemo } from "react";
import { isPermitted } from "util/PermissionsMixin";
import Routes from "routing/Routes";
import Modal from "components/bootstrap/Modal";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { useAddEvidence, useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useCurrentUser from "hooks/useCurrentUser";
import { Button, Table } from "components/bootstrap";
import { Icon, Link } from "components/common";
import { DataWell } from "common/components";
import { TD, TH } from "security-app/components/common";
import EvidenceSectionHeader from "security-app/components/Investigations/Details/OverviewSegment/EvidenceSectionHeader";
import SavedSearchesOverview from "./SavedSearchesOverview";
import { IconButton } from "../styled.components";
function Searches({ investigation, isExpanded, onToggleExpanded }) {
  const { permissions } = useCurrentUser();
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteSearchId, setDeleteSearchId] = useState(null);
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted(permissions, "investigations:edit"),
    [investigation.archived, permissions]
  );
  const { addEvidence } = useAddEvidence();
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const onAddSearch = async (id) => {
    await addEvidence({ invId: investigation.id, payload: { searches: [id] } }).then(() => {
      setShowAddModal(false);
    });
  };
  const removeSearch = async () => {
    await removeEvidence({ invId: investigation.id, payload: { searches: [deleteSearchId] } });
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  const onDelete = (searchId) => () => {
    setShowDeleteDialog(true);
    setDeleteSearchId(searchId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteSearchId(null);
  };
  const renderSearches = (searches) => /* @__PURE__ */ React.createElement(React.Fragment, null, searches.map((search) => /* @__PURE__ */ React.createElement("tr", { key: search.id }, /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(Link, { to: Routes.VIEWS.VIEWID(search.id) }, search.title)), /* @__PURE__ */ React.createElement(TD, null, search.type), canManageEvidence && /* @__PURE__ */ React.createElement(TD, null, /* @__PURE__ */ React.createElement(IconButton, { $danger: true, "aria-label": `Delete search ${search.title}`, onClick: onDelete(search.id) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" }))))));
  return /* @__PURE__ */ React.createElement(DataWell, { $color: "content" }, /* @__PURE__ */ React.createElement(
    EvidenceSectionHeader,
    {
      sectionName: "searches",
      title: "Searches",
      count: investigation.searches.length,
      isExpanded,
      onToggleExpanded,
      action: canManageEvidence ? /* @__PURE__ */ React.createElement(Button, { onClick: () => setShowAddModal(true) }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "sm" }), "Add Searches") : null
    }
  ), isExpanded && /* @__PURE__ */ React.createElement("div", { style: { marginTop: "0.5rem" } }, investigation.searches.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, "There are no searches to list") : /* @__PURE__ */ React.createElement(Table, { condensed: true, hover: true, className: "table table-striped" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement(TH, null, "Search Name"), /* @__PURE__ */ React.createElement(TH, null, "Search Type"), /* @__PURE__ */ React.createElement(TH, null))), /* @__PURE__ */ React.createElement("tbody", null, renderSearches(investigation.searches)))), /* @__PURE__ */ React.createElement(Modal, { show: showAddModal, bsSize: "large", onHide: () => setShowAddModal(false) }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, "Add Search")), /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(SavedSearchesOverview, { onAddSearch }))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Search",
      onConfirm: removeSearch,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Search?"
  ));
}
export default Searches;
